import { defineDynamicIcon } from './defineDynamicIcon';
import { getAnalyticsReportTitle } from './getAnalyticsReportTitle';
import { getShownReportPeriod } from './getShownReportPeriod';

export { getAnalyticsReportTitle, defineDynamicIcon, getShownReportPeriod };
